import { language } from 'shared/language';

export const INTERNAL_SERVER_ERROR = language.internal_server_error;
export const SOMETHING_WRONG = language.something_wrong;
export const USER_LOGIN_FAILED = language.username_or_password_not_right;
